import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = unknown
  const [ready, setReady] = useState(false);

  const checkSession = useCallback(async () => {
    if (!localStorage.getItem("admin_token")) {
      setUser(false);
      setReady(true);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("admin_token");
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => { checkSession(); }, [checkSession]);

  async function login(email, password) {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data?.access_token) localStorage.setItem("admin_token", data.access_token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) || e.message };
    }
  }

  async function logout() {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("admin_token");
    setUser(false);
  }

  return (
    <AuthCtx.Provider value={{ user, ready, login, logout, refresh: checkSession }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() { return useContext(AuthCtx); }
